module.exports = __webpack_public_path__ + "static/media/love-tarot.b315792c.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/love-tarot.png
// module id = 1540
// module chunks = 0